export const VENUE_DETAIL_ROUTE = '/studios';
